import React from 'react';
import { FaDiscord, FaTiktok, FaSteam, FaHeart } from 'react-icons/fa';
import "../styles/Footer.css";

const Footer = ({ openModal }) => {
    return (
        <footer className="footer-container">
            <div className="footer-content">
                <div className="footer-main">
                    <div className="social-buttons">
                        <a
                            href="https://discord.gg/b2AUPaj"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-button discord"
                            aria-label="Discord"
                        >
                            <FaDiscord />
                        </a>
                        <a
                            href="https://www.tiktok.com/@diegoysp"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-button tiktok"
                            aria-label="TikTok"
                        >
                            <FaTiktok />
                        </a>
                        <a
                            href="https://steamcommunity.com/id/Diegoysp/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-button steam"
                            aria-label="Steam"
                        >
                            <FaSteam />
                        </a>
                    </div>
                    <button
                        onClick={openModal}
                        className="footer-button"
                    >
                        <FaHeart />
                        <span>Donate Us</span>
                    </button>
                </div>
                <div className="footer-copyright">
                    © 2024 FaceitFinder. All rights reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
